<template>
  <div style="height:100%;background:#fff;border-radius:4px;padding:24px;">
    <div>
      <span style="color:rgba(18, 18, 18, 1);font-size:16px;font-weight:bold;">发送记录</span>
      <div style="display:inline-block;float:right">
        <a-dropdown style="margin:0 12px;" :trigger="['click']" v-if="ifShowDownLoad">
          <a-button type="primary" style="background: rgba(24, 144, 255, 1);">导出</a-button>
          <a-menu slot="overlay" style="text-align:center">
            <a-menu-item key="1" @click="outputAll">
              <div style="color:rgba(80, 80, 80, 1);font-size:14px;">下载全部</div>
              <div style="color:rgba(188, 188, 188, 1);font-size:12px;">请注意导出时间范围</div>
            </a-menu-item>
            <a-menu-divider />
            <a-menu-item key="2" @click="showOutputRecord">
              导出记录
            </a-menu-item>
          </a-menu>
        </a-dropdown>
        <span @click="doMessageSend" style="display: inline-block;width:88px;height:32px;line-height: 32px;text-align: center;cursor: pointer;background:rgba(66, 223, 228, 1);border-radius: 4px;font-size:14px;color:#fff;;">短信发送</span>
      </div>
    </div>
    <div style="margin-top:20px;">
      <a-row>
        <a-col :span="3">
          <div style="">
            <div style="color:rgba(18, 18, 18, 1);font-size:14px;">号码</div>
            <a-input v-model="phoneNum" style="margin-top:8px;width:80%" placeholder="请输入" />
          </div>
        </a-col>
        <a-col :span="6">
          <div style="">
            <div style="color:rgba(18, 18, 18, 1);font-size:14px;">发送时间</div>
            <a-range-picker style="margin-top:8px;width:90%;" v-model="timeData" :show-time="showTime" format="YYYY-MM-DD HH:mm:ss" :disabled-date="disabledDate"  />
          </div>
        </a-col>
        <a-col :span="3">
          <div style="">
            <div style="color:rgba(18, 18, 18, 1);font-size:14px;">发送状态</div>
            <a-select placeholder="请选择" style="width: 80%;margin-top:8px;margin-right:60px;" v-model="sendState">
              <a-select-option value="">
                全部
              </a-select-option>
              <a-select-option value="1">
                待发送
              </a-select-option>
              <a-select-option value="2">
                发送中
              </a-select-option>
              <a-select-option value="3">
                发送成功
              </a-select-option>
              <a-select-option value="4">
                发送失败
              </a-select-option>
            </a-select>
            
          </div>
        </a-col>
        <a-col :span="9">
          <div style="">
            <div style="color:rgba(18, 18, 18, 1);font-size:14px;">短信模板</div>
            <a-select placeholder="请选择" style="width: 100%;margin-top:8px;margin-right:60px;" v-model="msgSupport">
              <a-select-option :value="item.id" v-for="(item,index) in magTplList" :key='index'>
                <div v-html="item.templateContent"></div>
              </a-select-option>
            </a-select>
          </div>
          <!-- <div style="display:inline-block;">
            <div>项目ID</div>
            <a-input v-model="projectId" style="margin-top:8px;width:180px;" placeholder="请输入" />
          </div> -->
        </a-col>
        <a-col :span="3">
          <div style="float: right;margin-top:28px;">
            <span @click="resetCondition" style="display:inline-block;width:64px;height:32px;line-height:32px;text-align:center;cursor:pointer;background:#fff;color:rgba(121, 136, 155, 1);border:1px solid rgba(121, 136, 155, 1);border-radius:4px;font-size:14px;margin-right:12px;">重置</span>
            <span v-if="!ifShowDownLoad" @click="queryBasicData(1)" style="display:inline-block;width:64px;height:32px;line-height:32px;text-align:center;cursor:pointer;background:rgba(121, 136, 155, 0.16);color:rgba(121, 136, 155, 1);border:1px solid rgba(121, 136, 155, 1);border-radius:4px;font-size:14px;">查询</span>
          </div>
        </a-col>
      </a-row>
    </div>
    <div style="margin-top:24px;">
      <a-table
        :data-source="sendMsgRecord"
        :pagination="false"
        rowKey="id"
        tableLayout="fixed"
        :scroll="{ y: 'calc(100vh - 390px)' }"
      >
        <!-- 序号 -->
        <!-- <a-table-column
          key="index"
          title="批次ID"
          width="7%"
        >
          <template slot-scope="text, record, index">
            <span>{{ index + 1 }}</span>
          </template>
        </a-table-column> -->
        <a-table-column
          key="msgId"
          title="批次ID"
          data-index="msgId"
          width="7%"
        />

         <!-- 号码 -->
         <a-table-column
          key="phone"
          title="号码"
          data-index="phone"
          width="7%"
        />


        <!-- 模板ID -->
        <a-table-column
          key="fengxinTemplateId"
          title="模板ID"
          data-index="fengxinTemplateId"
          width="5%"
        />
        

        <!-- 短信内容 -->
        <a-table-column
          key="content"
          title="短信内容"
          data-index="content"
          width="36%"
        >
          <template slot-scope="text, record">
            <div
              :title="record.content"
              class="ellipsis"
            >
              {{ record.content.length > 70
                ? record.content.substring(0, 70) + '...'
                : record.content }}
            </div>
          </template>
        </a-table-column>

        <!-- 发送状态 -->
        <a-table-column
          key="status"
          title="发送状态"
          data-index="status"
          width="7%"
        />

        <!-- 计费条数 -->
        <a-table-column
          key="chargeCount"
          title="计费条数"
          data-index="chargeCount"
          width="5%"
        />

        <!-- 发送时间 -->
        <a-table-column
          key="sendTime"
          title="发送时间"
          data-index="sendTime"
          width="10%"
        />

       

        
      </a-table>

      <div class="pagination-table">
          <div class="total-info">
            <span>汇总计费条数：</span>
            <span>{{chargeCountSum}}</span>
          </div>
          <a-pagination
              class="pagination"
              show-size-changer
              :default-current="1"
              :total="total"
              @change="pageChange"
              @showSizeChange="onShowSizeChange"
          />
      </div>
    </div>
    <a-modal :centered='true' :maskClosable='false' v-model.trim="outputWarning" footer='' width='480px'>
      <div class="delete-modal modal-public">
          <div class="sure-off-bind">
              <a-icon type="warning" />
              <span>导出数据已超过最大限度</span>
          </div>
          <div class="tip1">当前条件数据{{total}}条，超过限制</div>
          <div class="tip2">请在查询区域，按时间段查询分次导出</div>
          <a-divider class="divider2" type="horizontal" />
          <div class="btn-group">
              <a-button type="primary" ghost @click="cancelOutput">取消</a-button>
              <a-button type="primary" @click="sureOutput">确定</a-button>
          </div>
      </div>
    </a-modal>
    <a-modal :centered='true' :maskClosable='false' v-model.trim="completeTip" footer='' width='480px'>
      <div class="delete-modal modal-public">
          <div class="sure-off-bind">
              <span>导出数据任务已完成</span>
          </div>
          
          <a-divider class="divider2" type="horizontal" />
          <div class="btn-group">
              <a-button type="primary" ghost @click="cancelComplete">取消</a-button>
              <a-button type="primary" @click="sureComplete">确定</a-button>
          </div>
      </div>
    </a-modal>
    <a-modal :centered='true' :maskClosable='false' v-model.trim="outputRecordBool" title="导出记录" footer='' width='1120px'>
      <div class="record-modal1 modal-public">
        <a-divider class="divider1" type="horizontal" />
        <div>
          <span style="color:rgba(18, 18, 18, 1);font-size: 14px;">创建时间：</span>
          <a-range-picker @change="dateChange" v-model="timeList2" format="YYYY-MM-DD HH:mm:ss"/>
          <span style="color:rgba(18, 18, 18, 1);font-size: 14px;margin-left:60px;">描述：</span>
          <a-input v-model="description" placeholder="请输入" style="display: inline-block;width:280px;"/>
          <div style="float: right;">
            <span @click="resetCondition2" style="display:inline-block;width:64px;height:32px;line-height:32px;text-align:center;cursor:pointer;background:#fff;color:rgba(121, 136, 155, 1);border:1px solid rgba(121, 136, 155, 1);border-radius:4px;font-size:14px;margin-right:12px;margin-left:72px">重置</span>
            <span @click="queryDownloadInfo" style="display:inline-block;width:64px;height:32px;line-height:32px;text-align:center;cursor:pointer;background:rgba(121, 136, 155, 0.16);color:rgba(121, 136, 155, 1);border:1px solid rgba(121, 136, 155, 1);border-radius:4px;font-size:14px;">查询</span>
          </div>
        </div>
        <a-table rowKey="id" style="margin-top:16px;" :data-source="outputData" :pagination='false' :loading="ifShowLoading" :scroll="{ y: 340 }">
          <a-table-column key="id" title="任务ID" data-index="id" />
          <a-table-column key="beginTime" title="开始时间" data-index="beginTime" />
          <a-table-column key="endTime" title="结束时间" data-index="endTime" />
          <a-table-column key="exportCount" title="导出数据量" data-index="exportCount" />
          <a-table-column key="description" title="描述" data-index="description" />
          <!-- <a-table-column key="status" title="进度" data-index="status">
              <template slot-scope="text, record">
                  <div v-if="record.status==1">
                      <span style="width:8px;height:8px;border-radius:4px;background:rgba(255, 195, 0, 1);display:inline-block;margin-right:8px;"></span>
                      <span>待执行</span>
                  </div>
                  <div v-if="record.status==2">
                      <span style="width:8px;height:8px;border-radius:4px;background:rgba(24, 144, 255, 1);display:inline-block;margin-right:8px;"></span>
                      <span>执行中</span>
                  </div>
                  <div v-if="record.status==3">
                      <span style="width:8px;height:8px;border-radius:4px;background:rgba(67, 207, 124, 1);display:inline-block;margin-right:8px;"></span>
                      <span>已完成</span>
                  </div>
              </template>
          </a-table-column> -->
          <a-table-column key="downloadUrl" title="附件" data-index="downloadUrl">
              <template slot-scope="text, record">
                  <div v-if="record.status==1">
                      <span style="width:8px;height:8px;border-radius:4px;background:rgba(255, 195, 0, 1);display:inline-block;margin-right:8px;"></span>
                      <span>待执行</span>
                  </div>
                  <div v-if="record.status==2">
                      <span style="width:8px;height:8px;border-radius:4px;background:rgba(24, 144, 255, 1);display:inline-block;margin-right:8px;"></span>
                      <span>执行中</span>
                  </div>
                  <div v-if="record.downloadUrl!=''">
                      <a :href="record.downloadUrl" style="cursor:pointer;color:#1890FF;">
                          <a-icon style="color:#1890FF;font-size:20px;;" type="download" />
                          下载
                      </a>
                  </div>
              </template>
          </a-table-column>
        </a-table>
        <div class="pagination-table" v-if="total2!=0">
          <div class="total-info">
            <span>总计：</span>
            <span>{{total2}}</span>
          </div>
          <a-pagination
              class="pagination"
              show-size-changer
              :default-current="1"
              :total="total2"
              @change="pageChange2"
              @showSizeChange="onShowSizeChange2"
          />
        </div>
        <div style="clear: both;"></div>
        <a-divider class="divider2" type="horizontal" />
        <div class="btn-group">
          <a-button type="primary" ghost @click="cancelRecordBool">取消</a-button>
          <a-button type="primary" @click="sureRecordBool">确定</a-button>
        </div>
      </div>
    </a-modal>
    <a-modal :centered='true' :maskClosable='false' v-model.trim="messageSendModal" title="短信发送" footer='' width='1100px'>
      <div class="record-modal1 modal-public">
        <a-divider style="margin:0 0 12px 0;" type="horizontal" />
        <div>
          <span style="color:rgba(18, 18, 18, 1);font-size:14px;margin-top:8px;float: left;">选择模板：</span>
          <a-radio-group style="margin-top:6px;" v-model="msgTplSign" @change="changeShareType($event)">
            <a-radio :value="1">
              我的
            </a-radio>
            <a-radio :value="2">
              共享
            </a-radio>
          </a-radio-group>
          <span @click="goCreateTpl" style="display: inline-block;width:122px;height:32px;line-height:32px;text-align: center;background: rgba(66, 223, 228, 1);color: #fff;font-size:13px;float: right;cursor: pointer;border-radius: 4px;">没有模板，去创建</span>
        </div>
        <div>
          <a-select v-model="tplSelected" placeholder="请选择" style="width: 100%;margin-top:8px;margin-right:60px;" @change="changeTpl">
            <a-select-option :value="item.id" v-for="(item,index) in magTplList" :key='index'>
              <div v-html="item.templateContent"></div>
            </a-select-option>
          </a-select>
        </div>
        <div style="margin-top:28px;">
          <div class="tab-list" v-if="hasVar!==''">
            <span v-if="hasVar===0" @click="selectTab(1)" :class="{'active':currentTab==1}">输入号码</span>
            <span v-if="hasVar===0" @click="selectTab(2)" :class="{'active':currentTab==2}">上传文件</span>
            <span v-if="hasVar==1" @click="selectTab(3)" :class="{'active':currentTab==3}">上传模板</span>
          </div>
          <div v-if="currentTab==1&&hasVar===0" style="height: 370px;border:1px solid rgba(121, 136, 155, 0.3);margin-top:16px;">
            <a-textarea placeholder="请输入" v-model="dataValue" style="height: 100%;border: none;resize: none;" />
          </div>
          <div style="height:370px;margin-top:16px;" v-if="currentTab==2&&hasVar===0">
            <a-upload-dragger
                key={Math.random()}
                name="file"
                :multiple="false"
                :customRequest="customRequest1"
                @change="onUpload1"
                ref="pathClear1"
            >
                <p class="ant-upload-drag-icon">
                    <a-icon type="upload" />
                </p>
                <p class="ant-upload-text">
                    点击或将文件拖拽到这里上传
                </p>
                <p class="ant-upload-hint">
                    支持扩展名：.txt 
                </p>
            </a-upload-dragger>
          </div>
          <div style="" v-if="currentTab==3&&hasVar==1">
            <div style="margin-top:16px;">
              <span style="color:rgba(80, 80, 80, 1);font-size:14px">*为保证数据导入顺利，请先</span>
              <a-button @click="downloadTemplate" icon="download" style="margin-left:8px">
              下载模板
              </a-button>
            </div>
            <div style="margin-top:24px;height: 314px">
              <a-upload-dragger
                key={Math.random()}
                name="file"
                :multiple="false"
                :customRequest="customRequest2"
                @change="onUpload2"
                ref="pathClear2"
              >
                  <p class="ant-upload-drag-icon">
                      <a-icon type="upload" />
                  </p>
                  <p class="ant-upload-text">
                      点击或将文件拖拽到这里上传
                  </p>
                  <p class="ant-upload-hint">
                      支持扩展名：.excel格式
                  </p>
              </a-upload-dragger>
            </div>
          </div>
        </div>
        <a-divider class="divider2" type="horizontal" />
        <div class="btn-group">
          <a-button type="primary" ghost @click="cancelMessageSend">取消</a-button>
          <a-button type="primary" @click="sureMessageSend">确定</a-button>
        </div>
      </div>
    </a-modal>
    <a-modal :centered='true' :maskClosable='false' v-model.trim="msgOutputBool" title="创建短信导出任务" footer='' width='506px'>
      <div class="modal-public">
        <a-divider class="divider1" type="horizontal" />
        <div style="display: flex;">
          <a-icon style="color:rgba(255, 170, 0, 1);font-size:16px;margin-top:4px;" type="exclamation-circle" />
          <div style="flex:1;margin-left:8px;">
            <div style="color:rgba(0, 0, 0, 1);font-size:16px;font-weight: bold;">请确认导出内容</div>
            <div style="display: flex;margin-top:20px;">
              <span style="color:rgba(18, 18, 18, 1);font-size: 14px;margin-top:6px;display: inline-block;width:98px;">导出数据数量：</span>
              <div style="flex:1;color:rgba(18, 18, 18, 1);font-size:20px">{{total}}条</div>
            </div>
            <div style="display: flex;margin-top:16px;">
              <span style="color:rgba(18, 18, 18, 1);font-size: 14px;margin-top:6px;display: inline-block;width:98px;">开始时间：</span>
              <div style="flex:1;color:rgba(18, 18, 18, 1);font-size:20px">{{moment(this.timeData[0], 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss')}}</div>
            </div>
            <div style="display: flex;margin-top:16px;">
              <span style="color:rgba(18, 18, 18, 1);font-size: 14px;margin-top:6px;display: inline-block;width:98px;">结束时间：</span>
              <div style="flex:1;color:rgba(18, 18, 18, 1);font-size:20px">{{moment(this.timeData[1], 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss')}}</div>
            </div>
            <div style="display: flex;margin-top:16px;">
              <span style="color:rgba(18, 18, 18, 1);font-size: 14px;margin-top:6px;display: inline-block;width:98px;">描述 (选填)：</span>
              <a-textarea v-model="outputDes" placeholder="请输入（选填）" style="flex:1;height:80px;" />
            </div>
          </div>
        </div>
        <a-divider class="divider2" type="horizontal" />
        <div style="text-align: right;padding-bottom:12px;">
          <a-button type="primary" ghost @click="cancelMsgBool">取消</a-button>
          <a-button type="primary" style="margin-left:8px;" @click="sureMsgBool">确定</a-button>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: 'SendRecord',
  props: {
    msg: String
  },
   data() {
    const start = moment().startOf('day')      // 当日 00:00:00
    const end   = moment().endOf('day')        // 当日 23:59:59
    return {
      outputWarning: false,
      completeTip: false,
      outputRecordBool: false,
      outputData: [],
      ifShowLoading: false,
      total: 0,
      currentPage: 1,
      pageSize: 10,
      sendState: undefined,
      msgSupport: undefined,
      integratedMsgData: [],
      phoneNum: '',
      timeData: [start, end],
      sendMsgRecord: [],
      chargeCountSum: 0,
      exportCount: 0,
      projectId: '',
      messageSendModal: false,
      currentTab: 1,
      newFormData1: '',
      newFormData2: '',
      tplSelected: undefined,
      dataValue: '',
      magTplList: [],
      batchId: '',
      hasVar: '',
      dataList: [],
      originFormData1: '',
      originFormData2: '',
      msgTplSign: 1,
      showTime: {
        defaultValue: [
          moment('00:00:00', 'HH:mm:ss'),
          moment('23:59:59', 'HH:mm:ss')
        ]
      },
      ifShowDownLoad: true,
      msgOutputBool: false,
      outputDes: '',
      description: '',
      total2: 0,
      currentPage2: 1,
      pageSize2: 10,
      timeList2: []
    }
  },
  watch: {
    phoneNum() {
      this.ifShowDownLoad = false
    },
    sendState() {
      this.ifShowDownLoad = false
    },
    msgSupport() {
      this.ifShowDownLoad = false
    },
    timeData: {
      handler() {
        this.ifShowDownLoad = false
      },
      deep: true   // ✅ 必须，加上才能监听 range-picker
    }
  },
  methods: {
    moment,
    outputAll() {
      if(this.total !=0){
        this.msgOutputBool = true
      }else{
        this.$message.warning('未查询到数据，无需下载')
      }
      
    },
    queryExportNum() {
      let startTime = '', endTime = ''
      if(this.timeData != null){
        startTime = moment(this.timeData[0], 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss')
        endTime = moment(this.timeData[1], 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss')
      }
      this.axios.post('/api/record/export/count', {
        phone: this.phoneNum,
        minSendTime: startTime,
        maxSendTime: endTime,
        sendStatus: this.sendState,
        smsSupplier: this.msgSupport,
        projectId: this.projectId
      })
      .then(response=> {
        if(response.data.code == 0){
          this.exportCount = response.data.data.exportCount
        }else{
          this.$message.error(response.data.userTip);
        }
      })
      .catch(error=> {
        console.log(error);
      });
    },
    cancelOutput() {
      this.outputWarning = false
    },
    sureOutput() {
      this.outputWarning = false
    },
    cancelComplete() {
      this.completeTip = false
    },
    sureComplete() {
      this.completeTip = false
    },
    showOutputRecord() {
      this.startTime = ''
      this.endTime = ''
      this.currentPage2 = 1
      this.pageSize2 = 10
      this.description = ''
      this.timeList2 = []
      this.outputRecordBool = true
      this.queryOutputData()
    },
    cancelRecordBool() {
      this.outputRecordBool = false
    },
    sureRecordBool() {
      this.outputRecordBool = false
    },
    pageChange(current, pageSize) {
      this.currentPage = current
      this.pageSize = pageSize
      this.queryBasicData(2)
    },
    onShowSizeChange(current, pageSize) {
      this.currentPage = current
      this.pageSize = pageSize
      this.queryBasicData(2)
    },
    queryBasicData(num) {
      let startTime = '', endTime = ''
      if(this.timeData != null){
        startTime = moment(this.timeData[0], 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss')
        endTime = moment(this.timeData[1], 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss')
      }
      if(num == 1){
        this.currentPage = 1
      }
      this.axios(
        {
          method:'get',
          url:'/api/smsRecord/list', 
          params: {
            current: this.currentPage,
            size: this.pageSize,
            phone: this.phoneNum,
            startTime: startTime,
            endTime: endTime,
            sendStatus: this.sendState,
            smsTemplateId: this.msgSupport,
          }
        }
      )
      .then(response=> {
        if(response.data.code == 0){
          this.sendMsgRecord = response.data.data.records
          this.total = response.data.data.total
          this.ifShowDownLoad = true
        }else{
          this.$message.error(response.data.userTip);
        }
      })
      .catch(error=> {
          console.log(error)
      })
      if(num == 1){
        this.axios(
          {
            method:'get',
            url:'/api/smsRecord/allChargeCount', 
            params: {
              phone: this.phoneNum,
              startTime: startTime,
              endTime: endTime,
              sendStatus: this.sendState,
              smsTemplateId: this.msgSupport,
            }
          }
        )
        .then(response=> {
          if(response.data.code == 0){
            this.chargeCountSum = response.data.data.allChargeCount
          }else{
            this.$message.error(response.data.userTip);
          }
        })
        .catch(error=> {
            console.log(error)
        })
      }
    },
    queryIntegratedMsg() {
      this.axios(
        {
          method:'get',
          url:'/api/supplier/list', 
        }
      )
      .then(response=> {
        if(response.data.code == 0){
          this.integratedMsgData = response.data.data
          // console.log(this.integratedMsgData)
        }else{
          this.$message.error(response.data.userTip);
        }
      })
      .catch(error=> {
        console.log(error)
      })
    },
    resetCondition() {
      const start = moment().startOf('day')      // 当日 00:00:00
      const end   = moment().endOf('day')        // 当日 23:59:59
      this.phoneNum = ''
      this.timeData = [start, end]
      this.sendState = undefined
      this.msgSupport = undefined
      this.queryBasicData(1)
    },
    // viewTpl(id) {
    //   console.log(id)
    // },
    dateChange(date, dateString) {
      // console.log(date)
      // console.log(dateString)
      this.startTime = dateString[0]
      this.endTime = dateString[1]
      // this.queryOutputData()
    },
    pageChange2(current, pageSize) {
      this.currentPage2 = current
      this.pageSize2 = pageSize
      this.queryOutputData()
    },
    onShowSizeChange2(current, pageSize) {
      this.currentPage2 = current
      this.pageSize2 = pageSize
      this.queryOutputData()
    },
    queryDownloadInfo() {
      this.currentPage2 = 1
      this.pageSize2 = 10
      this.queryOutputData()
    },
    resetCondition2() {
      this.startTime = ''
      this.endTime = ''
      this.currentPage2 = 1
      this.pageSize2 = 10
      this.description = ''
      this.timeList2 = []
      this.queryOutputData()
    },
    queryOutputData() {
      this.axios(
        {
          method:'get',
          url:'/api/smsRecord/export/list', 
          params: {
            minCreateTime: this.startTime,
            maxCreateTime: this.endTime,
            current: this.currentPage2,
            size: this.pageSize2,
            desc: this.description,
          }
        }
      )
      .then(response=> {
        if(response.data.code == 0){
          this.outputData = response.data.data.records
          this.total2 = response.data.data.total
        }else{
          this.$message.error(response.data.userTip);
        }
      })
      .catch(error=> {
        console.log(error)
      })
    },
    viewOutputDetail() {
      this.completeTip = false
      this.outputRecordBool = true
      // this.queryOutputData()
    },
    doMessageSend() {
      this.batchId = ''
      this.queryBatchId()
      this.tplSelected = undefined
      this.dataValue = ''
      this.newFormData1 = ''
      this.tplType = ''
      this.hasVar = ''
      this.msgTplSign = 1
      this.messageSendModal = true
    },
    cancelMessageSend() {
      this.messageSendModal = false
    },
    sureMessageSend() {
      this.dataList = []
      this.messageSendModal = false
      if(this.currentTab == 1&&this.hasVar == 0){
        if(this.dataValue!=''){
          this.dataList = this.dataValue.split('\n');
          this.sendMsg1()
        }
      }
      if(this.currentTab == 2&&this.hasVar == 0){
        this.sendMsg2()
      }
      if(this.currentTab == 3&&this.hasVar == 1){
        this.sendMsg3()
      }
    },
    sendMsg1() {
      this.axios.post('/api/smsRecord/addConstantSms', {
        batchId: this.batchId,
        smsTemplateId: this.tplSelected,
        phoneList: this.dataList,
      })
      .then(response=> {
        if(response.data.code == 0){
          this.resetCondition()
          this.$message.success('提交成功');
        }else{
          this.$message.error(response.data.userTip);
        }
      })
      .catch(error=> {
        console.log(error);
      });
    },
    sendMsg2() {
      const formData = new FormData() 
      formData.append('file', this.originFormData1.file)
      formData.append('batchId', this.batchId)
      formData.append('smsTemplateId', this.tplSelected)
      this.newFormData1 = formData
      this.axios({
        method: 'post',
        url: '/api/smsRecord/importConstantSms',
        headers:{
            'Content-Type':'application/x-www-form-urlencoded'
        },
        data: this.newFormData1,
      }).then((response) => {
        if(response.data.code == 0){
          this.$message.success('提交成功');
            this.newFormData1 = ''
            this.originFormData1 = ''
        }else{
            this.$message.error(response.data.userTip);
        }
      }).catch((error)=> {
        console.log(error)
      })
    },
    sendMsg3() {
      const formData = new FormData() 
      formData.append('file', this.originFormData2.file)
      formData.append('batchId', this.batchId)
      formData.append('smsTemplateId', this.tplSelected)
      this.newFormData2 = formData
      this.axios({
        method: 'post',
        url: '/api/smsRecord/importVarSms',
        headers:{
            'Content-Type':'application/x-www-form-urlencoded'
        },
        data: this.newFormData2,
      }).then((response) => {
        if(response.data.code == 0){
          this.$message.success('提交成功');
            this.newFormData2 = ''
            this.originFormData2 = ''
        }else{
            this.$message.error(response.data.userTip);
        }
      }).catch((error)=> {
        console.log(error)
      })
    },
    selectTab(type) {
      this.currentTab = type
    },
    customRequest1(data) { // 上传提交
      this.newFormData1 = ''
      this.originFormData1 = data
    },
    onUpload1() {
      this.$refs.pathClear1.value = ''
    },
    customRequest2(data) { // 上传提交
      this.newFormData2 = ''
      this.originFormData2 = data
    },
    onUpload2() {
      this.$refs.pathClear2.value = ''
    },
    downloadTemplate() {
      if(this.tplSelected!=''&&this.tplSelected!=undefined){
        window.open('/api/smsRecord/download/varSmsTemplate?smsTemplateId='+this.tplSelected, '_blank');
      }else{
        this.$message.error('请先选择模板')
      }
      
    },
    goCreateTpl() {
      this.$parent.selectNav('TemplateManagement')
      this.$router.push("/TemplateManagement")
    },
    formatSmsTemplate(text) {
      if (!text) return ''
      return text.length > 10
        ? text.slice(0, 10) + '...'
        : text
    },
    queryMsgTpl() {
      this.axios(
        {
          method:'get',
          url:'/api/templateManagement/selectList', 
          params: {
            shareStatus: this.msgTplSign,
          }
        }
      )
      .then(response=> {
        if(response.data.code == 0){
          // console.log(response.data.data)
          this.magTplList = response.data.data
        }else{
          this.$message.error(response.data.userTip);
        }
      })
      .catch(error=> {
        console.log(error)
      })
    },
    queryBatchId() {
      this.axios(
        {
          method:'get',
          url:'/api/smsRecord/batchNumber', 
        }
      )
      .then(response=> {
        if(response.data.code == 0){
          this.batchId = response.data.data.batchId
        }else{
          this.$message.error(response.data.userTip);
        }
      })
      .catch(error=> {
        console.log(error)
      })
    },
    changeTpl(value) {
      const item = this.magTplList.find(i => i.id === value)
      const hasVar = item ? item.hasVar : false
      this.hasVar = hasVar
      if(this.hasVar == 0){
        this.currentTab = 1
      }else{
        this.currentTab = 3
      }
      // console.log(this.tplSelected)
      this.$forceUpdate()
    },
    changeShareType(e) {
      this.tplSelected = undefined
      this.msgTplSign = e.target.value
      this.hasVar = ''
      this.currentTab = 1
      this.queryMsgTpl()
    },
    disabledDate(current) {
      if (!this.timeData || this.timeData.length === 0) {
        return false
      }

      const [start] = this.timeData
      if (!start) return false

      // 超过 31 天不可选
      return Math.abs(current.diff(start, 'days')) >= 31
    },
    cancelMsgBool() {
      this.msgOutputBool = false
    },
    sureMsgBool() {
      this.msgOutputBool = false
      let startTime = '', endTime = ''
      if(this.timeData != null){
        startTime = moment(this.timeData[0], 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss')
        endTime = moment(this.timeData[1], 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss')
      }
      this.axios.post('/api/smsRecord/export',{
        phone: this.phoneNum,
        startTime: startTime,
        endTime: endTime,
        sendStatus: this.sendState,
        smsTemplateId: this.msgSupport,
        desc: this.outputDes
      })
      .then(response=> {
        if(response.data.code == 0){
          // this.queryExportNum()
          // this.completeTip = true
          this.showOutputRecord()
        }else if(response.data.code == 'A0002'){
          // this.queryExportNum()
          this.outputWarning = true
        }else{
          this.$message.error(response.data.userTip)
        }
      })
      .catch(error=> {
        console.log(error)
      })
    }
  },
  mounted: function() {
    this.sessionData('set','contentNavItem','SendRecord');
    // this.queryIntegratedMsg()
    this.queryBasicData(1)
    this.queryMsgTpl()
  }
}
</script>

<style scoped lang="less">
  .pagination-table{
    padding-top: 24px;
    .total-info{
      float: left;
      color:rgba(121, 136, 155, 1);
      font-size: 14px;
    }
    .pagination{
      float: right;
    }
  }
  .modal-public{
    .divider1{
        margin: 0px 0 24px 0;
    }
    .divider2{
        margin: 24px 0 12px;
    }
    .btn-group{
      float: right;
      button{
          // width: 64px;
          height: 32px;
          font-size: 14px;
      }
      button:nth-child(1){
          margin-right: 16px;
      }
    }
    .btn-group2{
      float: right;
      button{
          // width: 64px;
          height: 32px;
          font-size: 14px;
      }
      button:nth-child(1){
          background: #fff;
          color: rgba(121, 136, 155, 0.7);
          border: 1px solid rgba(121, 136, 155, 0.5);
          margin-right: 16px;
      }
      button:nth-child(1):hover{
          background: rgba(121, 136, 155, 0.08);
      }
    }
  }
  .delete-modal{
    padding-top: 24px;
    padding-bottom: 44px;
    .sure-off-bind{
        i{
            color: rgba(255, 170, 0, 1);
            font-size: 24px;
        }
        span{
            color: rgba(18, 18, 18, 1);
            font-size: 20px;
            margin-left: 24px;
        }
    }
    .tip1{
        color: rgba(80, 80, 80, 1);
        padding-left: 50px;
        margin: 24px 0 10px 0;
        color: rgba(80, 80, 80, 1);
        font-size: 14px;
    }
    .tip2{
        color: rgba(80, 80, 80, 1);
        padding-left: 50px;
        color: rgba(80, 80, 80, 1);
        font-size: 14px;
    }
  }
  .record-modal1{
    padding-bottom: 44px;
    .changed-name{
      color: rgba(153, 153, 153, 1);
      font-size: 14px;
    }
  }
  .view-tpl{
    .tpl-content{
      display: none;
    }
  }
  .view-tpl:hover{
    .tpl-content{
      display: block;
    }
  }
  .tab-list{
    border-bottom:1px solid rgba(121, 136, 155, 0.3);
    span{
      color:rgba(18, 18, 18, 1);
      font-size: 14px;
      display: inline-block;
      height: 44px;
      line-height: 48px;
      padding: 0 15px;
      cursor: pointer;
    }
    span.active{
      color: rgba(66, 223, 228, 1);
      border-bottom: 3px solid rgba(66, 223, 228, 1);
      background: #ECFCFC;
    }
  }
  .ellipsis {
    max-width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>
